import React, { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppDataContext, VLink } from "../AppDataContext";
import LoginAndRegistration from "../LoginAndRegistration";

export function DashboardLayout(props) {
    const location = useLocation();
    const context = useContext(AppDataContext);

    const [isMyAccount, setIsMyAccount] = useState(null);
    const [currentTab, setCurrentTab] = useState(null);

    useEffect(() => {
        let currentTab = location.pathname.toLowerCase().replace("/dashboard", "").replace("/", "").trim();
        if (currentTab == "")
            currentTab = "favorites";
        setCurrentTab(currentTab)
    }, [location.pathname]);

    return (
        <>
        {
            context.isLoggedIn == false ?

                <div className={"row mb-5 mt-5"}>
                    <div class="offset-md-2 col-md-8 offset-lg-3 col-lg-6 offset-xl-4 col-xl-4">
                        <LoginAndRegistration
                            showLogin={true}
                            showSignup={false} />
                    </div>
                </div>
                :

                <>

                        <section class="background-color pt-2 pb-5 ">
                            <div class="container" >
                                <div class="row mt-3 sticky-top background-grey-lighter" >
                                    <div class="col-12 mb-4 ">
                                        <h4 class="auction-grid-header">
                                            Dashboard
                                            <div class="divider mt-2"></div>
                                        </h4>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <ul class="nav nav-tabs nav-justified nav-tabs-adjusted ">
                                            <li class="nav-item">
                                                <VLink to="/dashboard" className={"nav-link " + (currentTab == "favorites" || currentTab == "pastfavorites" ? "active" : "")}>Favorites</VLink>
                                            </li>
                                            <li class="nav-item">
                                                <VLink to="/dashboard/currentbids" className={"nav-link " + (currentTab == "currentbids" || currentTab == "pastitems" ? "active" : "")}>My Bids</VLink>
                                            </li>
                                            <li class="nav-item">
                                                <VLink to="/dashboard/invoices" className={"nav-link " + (currentTab == "invoices" ? "active" : "")}>Invoices</VLink>
                                            </li>
                                            <li class="nav-item">
                                                <VLink to="/dashboard/search" className={"nav-link " + (currentTab == "search" || currentTab == "auctioneers" ? "active" : "")}>Following</VLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="tab-content px-1">
                                    {props.children}
                                </div>


                        </div>
                    </section>
                </>
            }
        </>
    )


}
